// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"80":"76f30d41","254":"b0b012c3","281":"c0799c61","399":"0d6e8d64","503":"5a2aa219","508":"4ac95155","519":"fb705f07","977":"257532ad","981":"2e6ba43c"}[chunkId] + ".js";
};